<template>
  <page-template >
    <template slot="page-content">
      <div class="news--template page-template bg-beige">
      
        <div class="relative container-fluid mw9 center z-3 pt4 pb3 pb4-ns">
          <h1 class="mv0 ttu f-page-title is-blenny is-navy">{{ page.title }}</h1>
        </div>

        <div class="relative container-fluid mw9 center z-content">
          <div class="row">
            <div class="col-xs-12 col-sm-6 pb5" v-for="(post, index) in posts" v-if="index < 2" :key="'post-item-feat-' + index">
              <router-link class="db relative post-link" :to="post.url" :title="'View '+post.title">
                <div v-if="post.featured_image" class="news-zoom aspect-ratio--16x9" v-lazy:background="post.featured_image"></div> 
                <div v-else class="news-zoom aspect-ratio--16x9" v-lazy:background="'/uploads/refund.jpg'"></div>                   
                <h2 class="is-tablet-cond-bold f20px pt3 is-navy">{{ post.title }}</h2>
                <span class="db relative f4 mt3 ttu is-tablet-cond-bold is-navy">{{ post.date | formatDate }}</span>
                <p class="f15px is-tablet-regular pt3 lh-title is-black">{{ post.excerpt | truncate(140,'...') }}</p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="relative container-fluid mw9 center z-4 z-content pb4 pb6-ns">
          <div class="row">
            <div class="col-xs-12 col-sm-3 pb5" v-for="(post, index) in posts" v-if="index > 1 && index < 10" :key="'post-item-feat-' + index">
              <router-link class="post-link" :to="post.url" :title="'View '+post.title">
                <div v-if="post.featured_image" class="news-zoom aspect-ratio--16x9" v-lazy:background="post.featured_image"></div>
                <div v-else class="news-zoom aspect-ratio--16x9" v-lazy:background="'/uploads/refund.jpg'"></div>
                <h2 class="is-tablet-cond-bold f20px pt3 is-navy">{{ post.title }}</h2>
                <span class="db relative f4 mt3 ttu is-tablet-cond-bold is-navy">{{ post.date | formatDate }}</span>
              </router-link>
            </div>
          </div>
        </div>

        <div class="w-100 pb6 flex flex-column z-content">
          <div class="relative bg-teal pv5 relative">
            <div class="flex flex-column container-fluid relative z-4">
              <h2 class="f3 is-white center tc ttn lh-copy is-tablet-bold pv4 dib" id="outside-lands-app">We’ll send you the latest.</h2>
              <signup-form class="w-100 mw6 dib form-is-blue"></signup-form>
            </div>
            <div class="dn db-ns absolute bottom-0 right-0 mr3 mb3"><img class="mw4" src="/assets/images/bg-icons/ol20-hand-white.svg" /></div>
          </div>
        </div>

        <div class="relative container-fluid mw9 center z-4">
          <div class="row">
            <div class="col-sm-3 pb5" v-for="(post, index) in posts" v-if="index > 9" :key="'post-item-' + index">
              <router-link class="post-link" :to="post.url" :title="'View '+post.title">
                <img class="" alt="News" v-lazy="post.featured_image"/>
                <h2 class="is-tablet-cond-bold f20px pt3 is-black">{{ post.title }}</h2>
                <span class="db relative f4 mt3 ttu is-tablet-cond-bold is-navy">{{ post.date | formatDate }}</span>
              </router-link>
            </div>
          </div>
        </div>
        
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import SignupForm from './signup-form.vue';
export default {
  components: {
    PageTemplate,
    SignupForm,
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('news.markdown');
      return pageData[0];
    },
    posts: function () {
      var newsPosts = this.$store.getters.filterDataByCollection('posts');
      return newsPosts;
    },
  },
  methods : {
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
      this.scrollBg();
    },
    calcParallax: function(myTarget, offset, movement, positioning){
      if(this.$refs[myTarget]){
        this.parallax2 = false;
        if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
          var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
          return 'top:'+newMovement+'px;'+positioning;
        } else {
          return 'display:none;';
        }
      }
    },
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.sizing);
    //window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.sizing);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    this.$nextTick(() => {
      //
    })
  },
  beforeDestroy() {
    //
  },
  destroyed() {
    //
  }
}
</script>
